export default __webpack_public_path__ + "static/media/Road.20fc5aca.png";